module.exports = __webpack_public_path__ + "static/media/karza.c452cec2.png";